<div ngbDropdown class="d-inline-block" placement="bottom" display="dynamic" container="body">
    <button class="descarga-excel btn btn-outline-success btn-sm" ngbDropdownToggle id="dropdownExcel" [disabled]="loading || excelLinkDownload">
        <i class='fas fa-file-excel' *ngIf="!loading && !excelLinkDownload"></i>
        <div *ngIf="loading || excelLinkDownload">
            <i class='fas fa-circle-notch fa-spin'></i>
            <div class='percentage' *ngIf="!excelLinkDownload">
                {{getPercentage()}}
                &nbsp;
            </div>
            <div class='percentage' *ngIf="excelLinkDownload">
                <span *ngIf="porcentajeExcelBackend < 100 && carga < 2">0%</span>
                <span *ngIf="porcentajeExcelBackend < 100 && carga >= 2">{{porcentajeExcelBackend}}%</span>
                <span *ngIf="porcentajeExcelBackend >= 100">Generando Excel...</span>
                &nbsp;
            </div>
        </div>
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownExcel">
        <button 
            class='descarga-item'
            ngbDropdownItem
            *ngFor="let excel of datatable.excels"
            (click)="descargarExcel(excel)"
        >{{excel.nombre}}</button>
    </div>
</div>

<div class='cancelar-descarga' [hidden]="!loading">
    <i class='fas fa-times-circle hoverable fa-lg' [ngbPopover]="popContent" popoverTitle="¿Cancelar Descarga?" [placement]="'bottom'" [container]="'body'"></i>
</div>
<ng-template #popContent>
    <button class='btn btn-sm btn-danger btn-block' (click)="onCancelarDescargaClick()">Confirmar</button>
</ng-template>